<template>
  <div>
    <div>
      <label class="label">Search By:</label>
      <div>
        <input type="radio"
               v-model="mSearchBy.selected"
               v-bind:id="mSearchBy.options[0]"
               v-bind:value="mSearchBy.options[0]"
               v-bind:disabled="mSearchBy.disabled">
        <label class="ml-2" v-bind:for="mSearchBy.options[0]"> Vocus Account ID</label>

        <input type="radio"
               class="ml-3"
               v-model="mSearchBy.selected"
               v-bind:id="mSearchBy.options[1]"
               v-bind:value="mSearchBy.options[1]"
               v-bind:disabled="mSearchBy.disabled">
        <label  class="ml-2" v-bind:for="mSearchBy.options[1]"> House & Account #</label>
      </div>
    </div>
    <!-- search by inputs forms -->
    <div>
      <form class="form-group" v-on:submit.prevent="onClickSearch()">
        <div v-if="mSearchBy.selected === mSearchBy.options[0]">
          <input type="text"
                 class="form-control"
                 placeholder="Vocus Account ID"
                 v-model="mSearchBy.data.providerAccountId"
                 v-bind:disabled="mSearchBy.disabled">

        </div>
        <div v-else class="d-flex flex-row justify-content-between">
          <input type="text"
                 class="form-control"
                 placeholder="House #"
                 v-model="mSearchBy.data.houseNumber"
                 v-bind:disabled="mSearchBy.disabled">
          <input type="text"
                 class="form-control ml-2"
                 placeholder="Account #"
                 v-model="mSearchBy.data.accountNumber"
                 v-bind:disabled="mSearchBy.disabled">
        </div>
        <div class="d-flex flex-row justify-content-end mt-4">
          <button type="submit"
                  class="btn btn-outline-primary ml-2"
                  style="width: 10rem"
                  v-bind:disabled="!isValidSearchInput">
            Search
          </button>
        </div>

      </form>
    </div>
  </div>
</template>
<script>

import logger from "@/util/logger";

const LOG_TAG = 'search_by_card';

export default {
  name: LOG_TAG,
  props: {
    _disabled: {
      type: Boolean,
      default: function () {
        //{text: '', value: '', type: 'help', 'account'}
        return false;
      }
    },
    _onClickCb: {
      type: Function,
    }
  },
  data() {
    return {
      mSearchBy: {
        disabled: false,
        options: [
          'provider_account_id',
          'house_and_account'
        ],
        selected: 'provider_account_id',
        data: {
          providerAccountId: '',
          houseNumber: '',
          accountNumber: '',
        },
      },
    };
  },
  watch: {
    _disabled: function onChange(value) {
      logger.d(LOG_TAG, 'watch', '_disabled', value);
      const vm = this;
      vm.mSearchBy.disabled = value;
    },
  },
  computed: {
    searchBy() {
      return this.$store.state.searchBy;
    },
    isValidSearchInput() {
      const vm = this;
      let result = true;
      if (vm.mSearchBy.selected === vm.mSearchBy.options[0]) {
        result = vm.mSearchBy.data.providerAccountId.length > 0;
      } else if (vm.mSearchBy.selected === vm.mSearchBy.options[1]) {
        result = vm.mSearchBy.data.houseNumber && vm.mSearchBy.data.accountNumber;
      }
      return result && !vm.mSearchBy.disabled;
    },
  },
  mounted() {
    //
    const vm = this;
    const routeQuery = vm.$route.query;
    let skipCache = false;
    if (routeQuery.providerAccountId) {
      vm.mSearchBy.selected = vm.mSearchBy.options[0];
      vm.mSearchBy.data.providerAccountId = routeQuery.providerAccountId;

    } else if (routeQuery.houseNumber && routeQuery.accountNumber) {
      vm.mSearchBy.selected = vm.mSearchBy.options[1];
      vm.mSearchBy.data.houseNumber = routeQuery.houseNumber;
      vm.mSearchBy.data.accountNumber = routeQuery.accountNumber;

    } else {
      skipCache = true;
      if (vm.searchBy.providerAccountId) {
        vm.mSearchBy.selected = vm.mSearchBy.options[0];
        vm.mSearchBy.data.providerAccountId = vm.searchBy.providerAccountId;
      } else if (vm.searchBy.houseNumber && vm.searchBy.accountNumber) {
        vm.mSearchBy.selected = vm.mSearchBy.options[1];
        vm.mSearchBy.data.houseNumber = vm.searchBy.houseNumber;
        vm.mSearchBy.data.accountNumber = vm.searchBy.accountNumber;
      }
    }
    if (vm.isValidSearchInput) {
      vm.onClickSearch(skipCache);
    }
  },
  methods: {
    onClickSearch(skipCache) {
      const vm = this;
      if (vm.mSearchBy.selected == vm.mSearchBy.options[0]) {
        vm.mSearchBy.data.houseNumber = '';
        vm.mSearchBy.data.accountNumber = '';
      } else {
        vm.mSearchBy.data.providerAccountId = '';
      }
      vm._onClickCb(vm.mSearchBy.data);
      if (!skipCache) {
        vm.$store.commit('setSearchBy', vm.mSearchBy.data);
      }
    }
  }
}
</script>

<style scoped>

</style>
